import calculatedNewPrice from './calculatedNewPrice'
import statusDpoService from './statusDpoService'
import mountDpoService from './mountDpoService'
import companyTableGrid from './companyTableGrid'
import alertRenewalLessOneThirdDays from './alertRenewalLessOneThirdDays'
import limitCompaniesValidate from '../paymentContract/limitCompaniesValidate'

const PaymentContract = {
  calculatedNewPrice,
  statusDpoService,
  mountDpoService,
  companyTableGrid,
  alertRenewalLessOneThirdDays,
  limitCompaniesValidate,
}

export default PaymentContract
